module.exports = __webpack_public_path__ + "img/fresca.23bfc908.png";